import { render, staticRenderFns } from "./FormApiErrorModal.vue?vue&type=template&id=1b139802&scoped=true&"
import script from "./FormApiErrorModal.vue?vue&type=script&lang=ts&"
export * from "./FormApiErrorModal.vue?vue&type=script&lang=ts&"
import style0 from "./FormApiErrorModal.vue?vue&type=style&index=0&id=1b139802&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b139802",
  null
  
)

export default component.exports